﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcGridDetail from '@mescius/wijmo.grid.detail';
var WjFlexGridDetailBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridDetailBehavior, _super);
    function WjFlexGridDetailBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._openedComponents = [];
        return _this;
    }
    WjFlexGridDetailBehavior.render = function (createElement) {
        return VueApi.isV3Plus
            ? VueApi.h('div')
            : createElement('div');
    };
    WjFlexGridDetailBehavior.prototype._createControl = function () {
        var _this = this;
        var ctrl = _super.prototype._createControl.call(this);
        ctrl.createDetailCell = function (row) {
            if (VueApi.isV3Plus) {
                var h_1 = VueApi.h;
                var slotFn_1 = _this.component.$slots.default;
                var context_1 = {
                    row: row,
                    item: row.dataItem,
                    provider: _this.control,
                };
                var vnode = h_1({
                    parent: _this.component,
                    render: function () {
                        return h_1('div', {}, slotFn_1 && slotFn_1(context_1));
                    },
                });
                var container_1 = document.createElement('div');
                VueApi.render(vnode, container_1);
                _this._openedComponents.push({
                    '$destroy': function () {
                        VueApi.render(null, container_1);
                    }
                });
                return vnode.el;
            }
            else {
                // We need a view component that operates as a template root, in order
                // to get its HTMLElement which will be returned by createDetailCell.
                // childVN will be assigned with a result of the slot render function,
                // which will be a child of this template root component.
                var TemplRootCmp = VueApi.extend({
                    data: function () {
                        return {
                            childVN: null
                        };
                    },
                    render: function (createElement) {
                        return createElement('div', [this.childVN]);
                    }
                });
                // create root component
                var ret = new TemplRootCmp({ parent: _this.component });
                // assign slot rendering with scope properties
                ret.childVN = _this.component.$scopedSlots.default({
                    row: row,
                    item: row.dataItem,
                    provider: _this.control,
                });
                // Mount as detached component
                ret.$mount();
                // Store opened component to dispose it when it'll be closed
                _this._openedComponents.push(ret);
                // return component's html element
                return ret.$el;
            }
        };
        ctrl.disposeDetailCell = function (row) {
            var detailEl = row.detail, openedCmps = _this._openedComponents;
            if (detailEl) {
                // find and destroy the template root component
                for (var i = 0; i < openedCmps.length; i++) {
                    if (detailEl === openedCmps[i].$el) {
                        openedCmps[i].$destroy();
                        openedCmps.splice(i, 1);
                        break;
                    }
                }
            }
        };
        return ctrl;
    };
    WjFlexGridDetailBehavior.tag = 'wj-flex-grid-detail';
    WjFlexGridDetailBehavior.parentInCtor = true;
    WjFlexGridDetailBehavior.props = [
        'maxHeight',
        'keyActionEnter',
        'detailVisibilityMode',
        'rowHasDetail',
        'isAnimated'
    ];
    WjFlexGridDetailBehavior.events = [
        'initialized'
    ];
    WjFlexGridDetailBehavior.classCtor = function () { return wjcGridDetail.FlexGridDetailProvider; };
    return WjFlexGridDetailBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.detail.FlexGridDetailProvider} class.
 *
 * The <b>wj-flex-grid-detail</b> component should be contained in
 * a {@link wijmo.vue2.grid.WjFlexGrid} component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.detail.FlexGridDetailProvider} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexGridDetail = WjFlexGridDetailBehavior.register();
function registerV3WjFlexGridDetail(app) {
    app.component(WjFlexGridDetailBehavior.tag, WjFlexGridDetail);
}
export function registerGridDetail(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexGridDetail(app);
    }
}
